<template>
  <div class="user-avator-dropdown">
    <Dropdown @on-click="handleClick" :transfer="true" placement="bottom-end">
      <Badge :dot="!!messageUnreadCount">
        <!-- <Avatar src="http://pcphp.test.xcthings.com/fileuploads/logo/20250530/5d0f7cb1a83d4289d90ca953eb526207.png" /> -->
        
           <Avatar  :src="img_url" />
      </Badge>
      <!--<Icon :size="18" type="md-arrow-dropdown"></Icon>-->
      <DropdownMenu slot="list">
        <!--<DropdownItem name="message">-->
        <!--消息中心<Badge style="margin-left: 10px" :count="messageUnreadCount"></Badge>-->
        <!--</DropdownItem>-->
        <DropdownItem>{{ userName }}</DropdownItem>
        <!-- <DropdownItem name="ownSpace">{{$t('base.basicInformation')}}</DropdownItem> -->
        <DropdownItem name="timeZone">{{$t('时区设置')}}</DropdownItem>
        <DropdownItem name="center">{{$t('个人中心')}}</DropdownItem>
        <DropdownItem name="resetPass">{{$t('重置密码')}}</DropdownItem>
        <DropdownItem name="logout">{{$t('退出登录')}}</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
import "./user.less";
import { mapActions } from "vuex";
import { getToken } from "@/libs/util";
import certificationCom from "@/view/user/certification";
import resetPass from "./resetPass";
import center from "./center";
import timeZone from "./timeZone";
import { updatepwd } from "@/api/pests";
import { add_table_data, edit_platform } from "@/api/chuku";
import { set_timezone } from "@/api/jingxiaoshang";
import { get_website_data } from "@/api/chuku";
import config from  '@/config/index'
export default {
  name: "User",
  props: {
    // userAvator: {
    //   type: String,
    //   default: "",
    // },
    messageUnreadCount: {
      type: Number,
      default: 0,
    },
    userName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      formItem: {
        zhName: "",
        enName: "",
        image: null,
        select: "",
        img_url:null
      },
      insideSrc: null,
    };
  },
computed: {
  img_url() {
    const cachedUrl = localStorage.getItem('logo_url');
    const baseUrl =
      process.env.NODE_ENV === "development"
        ? config.baseUrl.dev
        : process.env.VUE_APP_BUILD === "production"
        ? config.baseUrl.pro
        : config.baseUrl.alp;

    return `${baseUrl}${cachedUrl || ''}`;
  }
},
  methods: {
    ...mapActions(["handleLogOut"]),
    logout() {
      // debugger
      this.handleLogOut({ token: getToken() }).then((res) => {
        // debugger
        this.$router.push({
          name: "login",
        });
      });
    },
    message() {
      this.$router.push({
        name: "message_page",
      });
    },
    ownSpace() {
      this.$router.push({
        name: "ownspace",
      });
    },
    /**
     * 重置密码
     */
    resetPass() {
      let vm = this;
      let config = {
        loading: true,
        width: 400,
        render: (h) => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "5px" } },
                  this.$t('重置密码')
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer",
                  },
                  on: {
                    click: (evt) => {
                      vm.$Modal.remove();
                    },
                  },
                }),
              ]
            ),
            h("Divider", {
              style: {
                margin: "8px 0",
              },
            }),
            h(resetPass, {
              ref: "resetPass",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: false,
              },
            }),
          ]);
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.resetPass;
          obj.checkForm().then((res) => {
            if (res) {
              //提交请求
              let formModel = obj.formMoblie;
              updatepwd(formModel).then((res) => {
                let msg = res.errorMsg;
                if (res.result === 0) {
                  let msg = res.errorMsg;
                  vm.$Message.success(msg);
                  vm.$Modal.remove();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },
    /**
     * 时区设置
     */
    timeZone() {
      let vm = this;
      let config = {
        loading: true,
        width: 400,
        render: (h) => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "5px" } },
                  this.$t('时区设置')
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer",
                  },
                  on: {
                    click: (evt) => {
                      vm.$Modal.remove();
                    },
                  },
                }),
              ]
            ),
            h("Divider", {
              style: {
                margin: "8px 0",
              },
            }),
            h(timeZone, {
              ref: "timeZone",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: true,
              },
            }),
          ]);
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.timeZone;
          obj.checkForm().then((res) => {
            if (res) {
              //debugger
              //提交请求
              let formModel = obj.formMoblie;
              console.log("111", formModel);
              set_timezone(formModel).then((res) => {
                let msg = res.errorMsg;
                if (res.result === 0) {
                  let msg = res.errorMsg;
                  vm.$Message.success(msg);
                  vm.$Modal.remove();
                  vm.$store.state.user.userInfo.timezone = formModel.timezone;
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },
    //实名认证
    certification() {
      let vm = this;
      let config = {
        loading: true,
        width: 800,
        okText: "确定",
        cancelText: "取消",
        render: (h) => {
          return h("div", [
            h("h3", "实名认证"),
            h(certificationCom, {
              ref: "certificationCom",
              props: {
                edit: true,
                _vm: vm,
                $store: vm.$store,
              },
            }),
          ]);
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.certificationCom;
          obj.formCheck().then((res) => {
            if (res) {
              //提交请求
              let formModel = obj.formModel;
              vm.$store
                .dispatch("handlereal_name_auth", formModel)
                .then((res) => {
                  if (res.result === 0) {
                    vm.$Message.success(this.$t('实名认证提交成功'));
                    vm.$Modal.remove();
                    //vm.init();
                  } else {
                    vm.$Message.error(vm.errorCode[res.result]);
                    _this.buttonLoading = false;
                  }
                });
            } else {
              _this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },
    helpSpace() {
      //打开帮助中心
      window.open("http://" + window.location.host + "/help");
    },
    personalCenter() {
      console.log("点击了个人中心");
      // this.modal1 = true;
      let vm = this;
      let config = {
        loading: true,
        width: 400,
        render: (h) => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "5px" } },
                  this.$t('个人中心')
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer",
                  },
                  on: {
                    click: (evt) => {
                      vm.$Modal.remove();
                    },
                  },
                }),
              ]
            ),
            h("Divider", {
              style: {
                margin: "8px 0",
              },
            }),
            h(center, {
              ref: "center",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: false,
              },
            }),
          ]);
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.center;
          obj.checkForm().then((res) => {
            if (res) {
              //提交请求
              console.log('obj.formModel',obj.formModel);
                let data = {
                  web_name: [
                    { "zh": obj.formModel.filename, "en": obj.formModel.merchant_name },
                  ],
                  logo_url: obj.formModel.fileinfo
                };
              edit_platform(data).then((res) => {
                let msg = res.errorMsg;
                if (res.result === 0) {
                  localStorage.setItem("shuaxin", obj.formModel.desc);
                  let msg = res.errorMsg;
                  vm.$Message.success(msg);
                  vm.$Modal.remove();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },
    beforeUpload(file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        this.insideSrc = event.srcElement.result;
      };
      return false;
    },
    handleClick(name) {
      // debugger
      switch (name) {
        case "logout":
          // debugger
          this.logout();
          break;
        case "resetPass":
          this.resetPass();
          break;
        case "timeZone":
          this.timeZone();
          break;
        case "ownSpace":
          this.ownSpace();
          break;
        case "certification":
          this.certification();
          break;
        case "feedbackList":
          this.feedbackList();
          break;
        case "center":
          this.personalCenter();
          break;
      }
    },
 
 
},
  mounted()  {
    //   get_website_data().then((res) => {
    //   console.log("登录信息111", res.body.logo_url);
    //   this.img_url= `${
    //       process.env.NODE_ENV === "development"
    //         ? config.baseUrl.dev
    //         : process.env.VUE_APP_BUILD === "production"
    //         ? config.baseUrl.pro
    //         : config.baseUrl.alp
    //     }${res.body.logo_url}`
    //     console.log("登录信息111", this.img_url);
    // });
  },
  
};
</script>
<style scoped>
.center {
  /* height: 600px; */
  overflow: auto;
}
.center::-webkit-scrollbar {
  display: none; /* 对于 Chrome, Safari 和 Opera */
}

.center {
  -ms-overflow-style: none; /* 对于 Internet Explorer 和 Edge */
  scrollbar-width: none; /* 对于 Firefox */
}
._img {
  width: 100%;
}
</style>